import React, { useState } from "react";

type Props = {
  mentorLanguagesList: any;
  minCount: number;
};

const MentorLanguagesList = ({ mentorLanguagesList, minCount }: Props) => {
  const [showSkills, setShowSkills] = useState(minCount);
  return (
    <div className="flex flex-wrap gap-3">
      {mentorLanguagesList
        .slice(0, showSkills)
        .map((item: any, index: number) => (
          <p
            key={index}
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7] cursor-pointer"
          >
            {item}
          </p>
        ))}
      {mentorLanguagesList.length > minCount &&
        (showSkills <= minCount ? (
          <p
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7] cursor-pointer"
            onClick={() => {
              setShowSkills(mentorLanguagesList.length);
            }}
          >
            +{mentorLanguagesList.length - minCount} More
          </p>
        ) : (
          <p
            className="text-[#111111E5] text-xs font-medium py-2 px-3 rounded-lg bg-[#A6C5F7] cursor-pointer"
            onClick={() => {
              setShowSkills(minCount);
            }}
          >
            Show Less
          </p>
        ))}
    </div>
  );
};

export default MentorLanguagesList;
